<template>
    <el-dialog :title="`${code} - ${name}`" :visible.sync="showMail" class="popup-mail-preview" width="70%" :before-close="backPopup">
        <el-form class="form-dialog">
            <div class="preview-address">
            <div class="preview-content content-left">
                <div>(Test)</div>
                <div v-if="data.test.from">From: {{ data.test.from }}. </div>
                <div v-if="data.to">To: {{ data.to }}. </div>
                <div v-if="data.test.cc">CC: {{ data.test.cc }}. </div>
                <div v-if="data.test.bcc">BCC: {{ data.test.bcc }}. </div>
                <div v-if="data.test.replyTo">Reply to: {{ data.test.replyTo }}. </div>
            </div>
            <div class="preview-content">
                <div>(Production)</div>
                <div v-if="data.prod.from"> From: {{ data.prod.from }}. </div>
                <div v-if="data.to">To: {{ data.to }}. </div>
                <div v-if="data.prod.cc">CC: {{ data.prod.cc }}. </div>
                <div v-if="data.prod.bcc">BCC: {{ data.prod.bcc }}. </div>
                <div v-if="data.prod.replyTo">Reply to: {{ data.prod.replyTo }}. </div>
            </div>
            </div>
            
            <div class="preview-content mail-subject">Subject: {{ data.subject }}</div>
            <div class="preview-content mail-body">
            <iframe :srcdoc="data.content" frameborder="0" width="100%" class="iframe-mail">
            </iframe>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="backPopup()">Thoát</el-button>
        </span>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            },
            showMail: Boolean,
            code: String,
            name: String
        },
        methods: {
            backPopup() {
                this.$emit('back-popup')
            }
        }
    }
</script>
<style scoped lang="scss">
  .form-space-between {
    display: flex;
  }
  .center-checkbox {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .margin-checkbox {
    margin-bottom: 8px;
  }
  .list-node-hide {
    display: flex;
    flex-direction: column;
  }
  .wrapper-node {
    align-items: center;
    border: 1px solid #cec6c5;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 0px 10px;
    position: relative;
  }
  .icon-detail {
    position: absolute;
    right: 10px;
    bottom: 9px;
    color: #717378;
    cursor: pointer;
  }
  .content-template {
    position: relative;
    button {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .preview-content {
    font-size: 15px;
    padding: 10px;
  }
  .mail-body {
    margin-top: 10px;
  }
  .preview-address {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .preview-content {
      width: 50%;
    }
  }
  .popup-mail-preview {
    .el-form {
      border: 1px solid #e4e7ed;
      .content-left {
        border-right: 1px solid #e4e7ed;
      }
      .mail-subject {
        border-bottom: 1px solid #e4e7ed;
      }
    }
  }
  :deep .el-dialog {
    margin: 50px auto !important;
  }
  .iframe-mail {
    height: 90vh;
  }
</style>
